/**
 * Profile API wrapper.
 * All /api/profile/* calls use the Bearer token from the current Supabase session.
 */
import supabase from '@/lib/supabaseClient';

const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8001';

async function authHeaders() {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) throw new Error('Not authenticated');
  return {
    Authorization: `Bearer ${session.access_token}`,
    'Content-Type': 'application/json',
  };
}

async function handleResponse(res) {
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.detail || `Request failed (${res.status})`);
  }
  return res.json();
}

export async function getProfile() {
  const headers = await authHeaders();
  const res = await fetch(`${API_URL}/api/profile`, { headers });
  return handleResponse(res);
}

export async function updateProfile(fields) {
  const headers = await authHeaders();
  const res = await fetch(`${API_URL}/api/profile`, {
    method: 'PUT',
    headers,
    body: JSON.stringify(fields),
  });
  return handleResponse(res);
}

export async function getBilling() {
  const headers = await authHeaders();
  const res = await fetch(`${API_URL}/api/profile/billing`, { headers });
  return handleResponse(res);
}

export async function updateBilling(fields) {
  const headers = await authHeaders();
  const res = await fetch(`${API_URL}/api/profile/billing`, {
    method: 'PUT',
    headers,
    body: JSON.stringify(fields),
  });
  return handleResponse(res);
}

export async function updateNotifications(fields) {
  const headers = await authHeaders();
  const res = await fetch(`${API_URL}/api/profile/notifications`, {
    method: 'PUT',
    headers,
    body: JSON.stringify(fields),
  });
  return handleResponse(res);
}

export async function completeSetup(fields) {
  const headers = await authHeaders();
  const res = await fetch(`${API_URL}/api/profile/setup`, {
    method: 'PUT',
    headers,
    body: JSON.stringify(fields),
  });
  return handleResponse(res);
}
